import { defineRecipe } from '@chakra-ui/react';

const textRecipe = defineRecipe({
    className: 'chakra-text',
    base: {
        fontSize: 'sm',
        fontFamily: 'body',
    },
});

export { textRecipe };
